import { listenerMiddleware } from '../listener.middleware';
import { Medication, medsApi } from '@/modules/surgicalEvent';
import { type RootState } from '@/store';
import { enqueueSnackbar } from 'notistack';
import isEqual from 'lodash/fp/isEqual';

const updatedByUserIds = new Set<string>();

listenerMiddleware.startListening({
  matcher: medsApi.endpoints.meds.matchFulfilled,
  effect: (action, api) => {
    const selectData = medsApi.endpoints.meds.select(
      action.meta.arg.originalArgs
    );

    const oldData = selectData(api.getOriginalState() as RootState).data;
    const newData = selectData(api.getState() as RootState).data;
    if (oldData && newData) {
      const isAutomated = (med: Medication) => !!med.valuesAutomated;
      const areAutomationValuesChanged = (med: Medication) => {
        const oldMed = oldData.find((m) => m.id === med.id);
        if (!oldMed) {
          return false;
        }

        const getMedName = ({ name }: Medication) => name;
        return (
          oldMed.interruptionStatus !== med.interruptionStatus ||
          oldMed.stopDaysBefore !== med.stopDaysBefore ||
          !isEqual(
            oldMed.bridgedBy?.map(getMedName),
            med.bridgedBy?.map(getMedName)
          )
        );
      };

      const filterUserUpdatesWithSideEffects = (med: Medication) =>
        !updatedByUserIds.delete(med.id);

      newData
        .filter(filterUserUpdatesWithSideEffects)
        .filter(isAutomated)
        .filter(areAutomationValuesChanged)
        .forEach((med) => {
          enqueueSnackbar('', {
            variant: 'medsAutomation',
            medication: med
          });
        });
    }
  }
});

listenerMiddleware.startListening({
  matcher: medsApi.endpoints.upsertMed.matchPending,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  effect: (action, api) => {
    if (action.meta.arg.originalArgs.medication.id) {
      updatedByUserIds.add(action.meta.arg.originalArgs.medication.id);
    }
  }
});
